import React from 'react'

export default React.createContext({
    minLength : 1,
    nbMinUppercases: 1,
    nbMinLowercases: 1,
    nbMinNumbers: 1,
    nbMinSpecialCharacters: 1
})
